<template>
	<Component :is="doctype" v-if="doctype" v-bind="content" />
</template>

<script setup>
import { useMainStore } from '~/store/main';
import doctypes, { getDoctypeFromTemplate } from '~/assets/js/doctypes';
import { useLimboFormLink } from '~/composables/useLimboForm';
const route = useRoute();

// Nuxt meta information for component
definePageMeta({
	middleware: ['auth'],
	// Set whatever layout you want the page to use or get it based on the template
	layout: false,
	key: (route) => route.path,
});


// Fetch page data
const { $umbracoClient } = useNuxtApp();
let data = await $umbracoClient.fetchData({
	params: {
		...route.query,
		cache: false,
		parts: ['content'].filter(Boolean),
	},
	route: route.path,
});

// Redirect
if (data?.meta?.code === 301 || data?.meta?.code === 302) {
	const url = new URL(data.data.url, 'https://www.example.com');
	await navigateTo([url.pathname, url.search, url.hash].join(''), {
		redirectCode: data.meta.code,
	});
}

// Process the data
const { content } = $umbracoClient.processData(data);

// Print
if (
	['MbaSpecialPageMbaTaskPdf', 'MbaSpecialPageMbaProjectPdf'].includes(
		content?.template
	)
) {
	const url = useLimboFormLink(content?.forms?.[0]);
	console.log(url, 'not sure what to do with it');
}

// Error
if (data.meta.code === 404 || !content) {
	setResponseStatus(data.meta.status);
	throw createError({
		statusCode: 404,
		statusMessage: 'Page Not Found',
		fatal: true,
	});
}

// Page meta information
if (content?.meta) {
	useHead(content.meta);
}

const templateName = getDoctypeFromTemplate(content.template);
const doctype =
	doctypes[
		Object.keys(doctypes).includes(templateName)
			? templateName
			: 'ContentPage' // Fallback
	];
// TODO: add fallback handling for meta?
</script>
